import React from 'react';

const JS_Scope = () => {
  return (
    <div >
      <h1>JS_Scope</h1>
      <p>Placeholder component for: "JS Scope"</p>
    </div>
  );
};

export default JS_Scope;
